import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '../app/hooks';
import SubSection from './SubSection';
import { OrderingOperations } from 'polygon-ordering';
import SavedAddresses from './SavedAddresses';
import SectionHeading from './SectionHeading';
import SectionContainer from './SectionContainer';
import RedcatMapIcon from './icons/redcat/RedcatMapIcon';
import getThemeLookup from '../selectors/getThemeLookup';
import { resetForm, setSelectedAddress, updateForm } from '../slices/deliveryAddressForm';
import { getGeocodingDetailsAsync } from '../libs/polygon-utils/src/GoogleMapsApiHandler';

const { clearBuffer } = OrderingOperations;

const SelectDeliveryAddress = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const p = useAppSelector(getThemeLookup);

  const googleMapsApiKey = useAppSelector(state => state.config.googleMapsApiKey);
  const userLocation = useAppSelector(state => state.currentUserLocation);

  const onAddNewAddressClicked = async () => {
    dispatch(resetForm());
    dispatch(clearBuffer({}));

    if (userLocation && googleMapsApiKey) {
      let address: DeliveryAddress;
      try {
        address = await getGeocodingDetailsAsync(
          fetch,
          googleMapsApiKey,
          userLocation.latitude,
          userLocation.longitude,
        );
        dispatch(setSelectedAddress(address));
      } catch {
        // TODO: We should handle this error properly rather than swallowing it
      }
    }

    dispatch(updateForm({ page: 'AddressLookupAndConfirmation' }));
  };

  return (
    <>
      <SectionHeading title={t('title.deliveryAddressTitle')} containerStyle={styles.sidePadding} />
      <SectionContainer style={styles.sidePadding}>
        <SubSection
          title={t('button.enterNewAddress')}
          action={onAddNewAddressClicked}
          leftIcon={() => <RedcatMapIcon />}
          titleStyle={p('addDeliveryAddressButton', ['color'])}
          leftIconStyle={p('addDeliveryAddressButton', ['color'])}
        />
        <SavedAddresses />
      </SectionContainer>
    </>
  );
};

const styles: Styles = {
  sidePadding: {
    paddingLeft: 16,
    paddingRight: 16,
  },
};

export default SelectDeliveryAddress;
